import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomTabs, CustomTab } from '../components/CustomTabs';
import PontosFortes from './PontosFortes';
import PontosFracos from './PontosFracos';

const AmbienteInterno: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ margin: 'auto' }}>
      <CustomTabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        variant="fullWidth"
      >
        <CustomTab tabTitle="Pontos Fortes" content={<PontosFortes />} />
        <CustomTab tabTitle="Pontos Fracos" content={<PontosFracos />} />
      </CustomTabs>
    </Box>
  );
};

export default AmbienteInterno;